<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    width="40%"
  >
    <el-form :model="data" :rules="rules" ref="addForm" label-width="100px">
      <el-form-item label="公司名称:" prop="companyName">
        <el-input v-model="data.companyName" :maxlength="32" placeholder="请填写" clearable />
      </el-form-item>
      <el-form-item label="任职周期:" prop="time">
        <el-date-picker v-model="data.takeOfficeStartTime" type="year" value-format="yyyy" placeholder="选择年" style="width: 200px"></el-date-picker>
        ——
        <el-date-picker v-model="data.takeOfficeEndTime" type="year" value-format="yyyy" placeholder="选择年" style="width: 200px"></el-date-picker>
      </el-form-item>
      <el-form-item label="部门:" prop="apartment">
        <el-select v-model="data.apartment" placeholder="请选择" clearable style="width:100%">
          <el-option
            v-for="dict in contactDeptOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="职务:" prop="position">
        <el-input v-model="data.position" :maxlength="32" placeholder="请输入职务" clearable />
      </el-form-item>
      <el-form-item label="业务决策人:" prop="isDecisionMaker">
        <el-radio-group v-model="data.isDecisionMaker">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否在职:" prop="isOnTheJob">
        <el-radio-group v-model="data.isOnTheJob">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="履历描述:" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 5}"
          :maxlength="500"
          show-word-limit
          v-model="data.remark"
          placeholder="请填写联系人所在公司的履历描述"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { emailValid } from "@/utils/validator";
import { isPhone } from "@/utils/validate";
import { addResume, updateResume, queryResumeDetail } from "@/api/crm/contact";

export default {
  name: "AddContactDialog",
  props: {
    contactId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      title: null,
      customerList: [],
      customerDisabled: false,
      contactDeptOptions: [],
      rules: {
        companyName: [
          { required: true, message: "请填写公司名称", trigger: "change" }
        ],
        apartment: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change"
          }
        ]
      },
      data: {
        time: [],
        contactId: null,
        companyName: null,
        apartment: null,
        position: null,
        isDecisionMaker: 0,
        isOnTheJob: 0,
        remark: null,
        takeOfficeStartTime: null,
        takeOfficeEndTime: null
      }
    };
  },
  created() {
    this.getDicts("contact_dept").then(response => {
      this.contactDeptOptions = response.data;
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.data.takeOfficeStartTime = null
        this.data.takeOfficeEndTime = null
        this.data.id = null
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    goAddUser() {
      this.$router.push("/crm/customer/manage");
    },
    open(type, data) {
      if (type == "edit") {
        this.title = '编辑任职履历'
        this.$nextTick(function(){
          this.data = JSON.parse(JSON.stringify(data))
        })
      }else {
        this.title = '新增任职履历'
      }
      this.visible = true;
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          this.data.contactId = this.contactId;
          if (this.data.id) {
            updateResume(this.data)
              .then(response => {
                this.$emit("success");
                this.visible = false;
                loading.close();
                this.msgSuccess("编辑成功");
              })
              .catch(error => {
                loading.close();
              });
          } else {
            addResume(this.data)
              .then(response => {
                this.$emit("success");
                this.visible = false;
                loading.close();
                this.msgSuccess("新增成功");
              })
              .catch(error => {
                loading.close();
              });
          }
        } else {
        //   this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
